<template>
  <div class="container-lg">
    <solicitudes
      ref="solicitudes"
      :columnas="Columnas"
      :busqueda="busqueda"
      :cargaManual="cargaManual"
      :facade="Facade"
      :pendingFacade="PendingFacade"
    >
      <template slot="modalTitulo">Comentario</template>
      <template v-slot:modalCuerpo="slotProps">
        <div class="cuerpo-modal" v-if="slotProps.item">
          <p><strong>Título:</strong> {{ slotProps.item.titulo }}</p>
          <p><strong>Cuerpo:</strong> {{ slotProps.item.cuerpo }}</p>
          <p><strong>Usuario:</strong> {{ slotProps.item.nombreUsuario }}</p>
        </div>
      </template>
    </solicitudes>
  </div>
</template>

<script>
import { ComentarioFacade as Facade } from "../../admin/comentario/comentario.facade";
import { ComentarioPendingFacade as PendingFacade } from "../../admin/comentario/comentario-pending.facade";
import Solicitudes from "./Solicitudes.vue";

const COLUMNAS = [
  {
    clave: "nombreComercio",
    cabecera: "Comercio"
  },
  {
    clave: "estrellas",
    cabecera: "Estrellas"
  },
  {
    clave: "titulo",
    cabecera: "Título"
  }
];

export default {
  components: {
    Solicitudes
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean
  },
  computed: {
    Columnas() {
      return COLUMNAS;
    },
    Facade() {
      return Facade;
    },
    PendingFacade() {
      return PendingFacade;
    }
  },
  methods: {
    // Los Eventos son llamados desde afuera
    /** Evento proxy para pasar a las tablas de comentarios */
    EventoRecargar() {
      this.$refs.solicitudes.recargar();
    }
  }
};
</script>
<style scoped>
.cuerpo-modal {
  text-align: left;
}
</style>
